import sAction from 'sAction';

export default function getModuleName(urlModule = null) {
    if (urlModule === null) {
        let url = window.location.hash;
        url = url.replace('#', '').split('?')[0];
        url = url.split('/');
        urlModule = url[1] || url[0];
    }

    if (!urlModule || urlModule === 'home') {
        return 'home';
    }

    return sAction?.urlModuleMap?.[urlModule] || urlModule;
}
